const APP_HEIGHT_VAR = "--mixitone-app-height";
const APP_OFFSET_TOP_VAR = "--mixitone-vv-offset-top";

/** Visible viewport height. 100vh / innerHeight can include area behind mobile browser chrome. */
export function appViewportHeightPx(): number {
  const visual = window.visualViewport?.height;
  if (typeof visual === "number" && visual > 0) {
    return Math.round(visual);
  }
  return Math.round(window.innerHeight);
}

/**
 * Distance from the layout viewport top to the visible viewport.
 * Grows when the on-screen keyboard pans the visual viewport.
 */
export function appViewportOffsetTopPx(): number {
  const offset = window.visualViewport?.offsetTop;
  if (typeof offset === "number" && Number.isFinite(offset) && offset > 0) {
    return Math.round(offset);
  }
  return 0;
}

export function applyAppViewportHeight(): void {
  const root = document.documentElement;
  root.style.setProperty(APP_HEIGHT_VAR, `${appViewportHeightPx()}px`);
  root.style.setProperty(APP_OFFSET_TOP_VAR, `${appViewportOffsetTopPx()}px`);
}

/** Keep the app shell sized to the visible viewport as mobile browser chrome and the keyboard show and hide. */
export function startAppViewportHeightSync(): void {
  applyAppViewportHeight();
  requestAnimationFrame(applyAppViewportHeight);

  window.visualViewport?.addEventListener("resize", applyAppViewportHeight);
  window.visualViewport?.addEventListener("scroll", applyAppViewportHeight);
  window.addEventListener("resize", applyAppViewportHeight);
}
